import entries from './entries';
import groupFormEntries from './groupFormEntries';


/**
 * @param {HTMLFormElement|HTMLFormControlsCollection} $formOrControls
 */
export default function serialize($formOrControls) {
  const $controls = $formOrControls.elements || $formOrControls;

  return groupFormEntries(entries($controls));
}



// WEBPACK FOOTER //
// ./src/utils/form/serialize.js